import * as React from 'react';
export const IcCropPlanningStyle3 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.55 11.83l.07-.07a1 1 0 00.15-.14l.1-.15c.028-.058.051-.118.07-.18a1.172 1.172 0 000-.2L21 11V5a1 1 0 00-2 0v1.46l-1 .67V4a1 1 0 00-2 0v3.13l-1-.67V5a1 1 0 00-2 0v6.09a1.172 1.172 0 000 .2c.02.062.043.122.07.18.03.052.063.102.1.15a1 1 0 00.15.14l.07.07L16 13.54V17a3.84 3.84 0 01-1.35-.38A5.66 5.66 0 0012 16a5.67 5.67 0 00-2.66.59A3.79 3.79 0 018 17v-2.46l2.55-1.71.07-.07a1 1 0 00.15-.14c.037-.048.07-.098.1-.15.028-.058.051-.118.07-.18a1.172 1.172 0 000-.2L11 12V6a1 1 0 00-2 0v1.46l-1 .67V5a1 1 0 10-2 0v3.13l-1-.67V6a1 1 0 10-2 0v6.09a1.18 1.18 0 000 .2c.02.062.042.122.07.18l.1.15a1 1 0 00.15.14l.07.07L6 14.54v2.2l-.37-.15a6.002 6.002 0 00-1.45-.48 1 1 0 00-.82.21 1 1 0 00-.36.77V20a1 1 0 001 1h16a1 1 0 001-1v-2.91a1.001 1.001 0 00-.36-.77 1 1 0 00-.82-.21 6.08 6.08 0 00-1.46.48l-.36.15v-3.2l2.55-1.71zM18 9.54l1-.67v1.59l-1 .67V9.54zm-10 1l1-.67v1.59l-1 .67v-1.59zm-2 1.59l-1-.67V9.87l1 .67v1.59zm10-1l-1-.67V8.87l1 .67v1.59z'
      fill='currentColor'
    />
  </svg>
);
